'use client';

import React from 'react';
import getHTML from '@shared/get-html';
import { type BuyerLayoutProps } from 'shop-ui/types';

interface ContentPropTypes extends BuyerLayoutProps<Product> {}

export const StandardContent: React.FC<ContentPropTypes> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    const { descriptions } = product;

    return (
        <>
            {descriptions?.map((i, idx) => {
                return (
                    <div key={i.title + i.id + idx}>
                        <div className="skeleton skeleton--ssr skeleton--md_sw">
                            <h2 className="ssr-hidden">{i.title}</h2>
                        </div>
                        <div className="skeleton-spacer"></div>
                        <div className="skeleton skeleton--ssr skeleton--sm" />
                        <div className="skeleton-spacer"></div>
                        <div className="skeleton skeleton--ssr skeleton--md" />
                        <div className="skeleton-spacer"></div>
                        <div className="skeleton skeleton--ssr skeleton--lg" />
                        <div className="skeleton-spacer"></div>
                        <div className="skeleton-spacer"></div>
                        <div className="skeleton-spacer"></div>
                        <div className="skeleton skeleton--ssr skeleton--md" />
                        <div className="skeleton-spacer"></div>
                        <div className="skeleton skeleton--ssr skeleton--sm" />
                        <div className="ssr-hidden">{getHTML(i.description, 'div')}</div>
                    </div>
                );
            })}
        </>
    );
};
